import TSWLogo from '../../../Assets/tswLogo.png';

const Logo = () => {
  return <img src={TSWLogo} alt='Sports South Logo' style={{}} />;
};

export default Logo;
